module.exports = __webpack_public_path__ + "static/media/male-teacher_1f468-200d-1f3eb-2.ad99eccb.png";